import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";

import { useMutation } from "@tanstack/react-query";

import { Plants } from "../../../api/plants";
import { PlantRoots } from "../../../api/types/plants";
import { MutationKey } from "../../../consts/mutation-keys";
import { QueryKey } from "../../../consts/query-keys";
import { useApiError } from "../../../hooks/useApiError";
import { useApiSuccess } from "../../../hooks/useApiSuccess";
import { ApiHookConfig } from "../../../types/api-hook-config";
import { CafsForm } from "../../../types/cafs-form";

export const useRootsUpdate = ({ onSuccess }: ApiHookConfig) => {
  const { datasetId, id } = useParams();
  const { formatMessage } = useIntl();
  const { handleSuccess } = useApiSuccess({
    invalidate: [
      [QueryKey.RootsSection],
      [QueryKey.CafsDetails],
      [QueryKey.PlantAudit],
    ],
    snackbarText: formatMessage({
      id: "ACTIONS.ROOTS_UPDATE_SUCCESS",
      defaultMessage: "Plant roots updated successfully.",
      description: "Plant roots update success message",
    }),
    onSuccessFn: onSuccess,
  });

  const { handleError, apiErrors } = useApiError();

  const mutationFn = (data: Partial<CafsForm<PlantRoots>>) =>
    Plants.updateRoots(
      {
        path: { datasetId: +datasetId! as number, plantId: +id! as number },
      },
      data,
    );

  const { mutate: updateRoots, isPending } = useMutation({
    mutationKey: [MutationKey.SaveRootsSection, datasetId, id],
    mutationFn: mutationFn,
    onSuccess: handleSuccess,
    onError: handleError,
  });

  return { updateRoots, apiErrors, isPending };
};
